import React from "react";
import PrivacyContent from "./PrivacyContent";

const Privacy = () => {
	return (
		<div className="privacy-policy-page">
			<section className="hero-section bg-[#ECF2FB] flex flex-col items-center justify-center text-center py-24 md:py-32 px-6">
				<h1 className="text-4xl md:text-6xl font-SatoshiBold text-headerblue">
					Privacy Policy
				</h1>
				<p className="mt-4 max-w-2xl font-SatoshiRegular text-[#475467]">
					How Bankolé collects, uses, and protects your information across our
					web platform, mobile applications, and related services.
				</p>
			</section>
			<PrivacyContent />
		</div>
	);
};

export default Privacy;
